import { Component, OnInit } from '@angular/core';
import * as p5 from 'p5';

@Component({
  selector: 'app-sketch-demo',
  templateUrl: './sketch-demo.component.html',
  styleUrls: ['./sketch-demo.component.css']
})
export class SketchDemoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    /* create sketch environment */
    var sketch = (p) => {


      let nrDots = 600;
      let dotSize = 2;
      let dotSpeed = 20; //pixels per second
      let dotDir = 0;
      let patchR = 100;
      var dotCoords_X = Array(nrDots);
      var dotCoords_Y = Array(nrDots);
      var timestamp, curTime, lastTime, dt;
      var flagTest;
      let nrArrows = 200;
      var arrCoords_X = Array(nrArrows);
      var arrCoords_Y = Array(nrArrows);

      p.setup = function () {
        var canvas = p.createCanvas(300, 300);
        canvas.parent('sketch-demo-holder');

        for (var ii = 0; ii < nrDots; ii++) {
          dotCoords_X[ii] = p.random(-patchR, patchR);
          dotCoords_Y[ii] = p.random(-patchR, patchR);
        }

        for (var ii = 0; ii < nrArrows; ii++) {
          arrCoords_X[ii] = p.random(-patchR, patchR);
          arrCoords_Y[ii] = p.random(-patchR, patchR);
        }

        curTime = p.millis();
        timestamp = curTime;
        flagTest = 0;
      }

      p.draw = function () {
        p.background(128);
        p.noCursor();
        p.angleMode(p.DEGREES);
        lastTime = curTime;
        curTime = p.millis();
        dt = (curTime - lastTime) / 1000;

        if (flagTest === 0 || flagTest === 1) {
          //draw motion pattern
          p.push();// Start a new drawing state
          p.translate(150, 150);
          //draw dots
          p.noStroke()
          p.fill(255)
          for (var ii = 0; ii < nrDots; ii++) {
            // draw the dot if within a circular apperture
            if ((p.pow(dotCoords_X[ii], 2) + p.pow(dotCoords_Y[ii], 2)) < p.pow(patchR, 2)) {
              p.ellipse(dotCoords_X[ii], dotCoords_Y[ii], dotSize);
              //					console.log(dotCoords_X[ii],dotCoords_Y[ii],dotCoords_X[ii]^2,dotCoords_Y[ii]^2,patchR^2)
            }
            // update position
            dotCoords_X[ii] += p.cos(dotDir) * dotSpeed * dt;
            //check if running out of bounds
            if (dotCoords_X[ii] >= patchR) {
              dotCoords_X[ii] -= 2 * patchR;
            } else if (dotCoords_X[ii] <= -patchR) {
              dotCoords_X[ii] += 2 * patchR;
            }
            dotCoords_Y[ii] += p.sin(dotDir) * dotSpeed * dt;
            //check if running out of bounds
            if (dotCoords_Y[ii] >= patchR) {
              dotCoords_Y[ii] -= 2 * patchR;
            } else if (dotCoords_Y[ii] <= -patchR) {
              dotCoords_Y[ii] += 2 * patchR;
            }

          }
          p.pop();

          p.push();// Start a new drawing state for the fixation dot in the middle
          p.translate(150, 150);
          p.noStroke();
          p.fill(128);
          p.ellipse(0, 0, 40);
          p.fill(0, 255, 0);
          p.ellipse(0, 0, 10);
          p.pop();
        } else {
          // draw arrows for responses
          p.stroke(255);
          for (var ii = 0; ii < nrArrows; ii++) {
            if ((p.pow(arrCoords_X[ii], 2) + p.pow(arrCoords_Y[ii], 2)) < p.pow(patchR, 2)) {
              drawArrow(arrCoords_X[ii], arrCoords_Y[ii], 270 + 30 * p.exp(-(curTime - timestamp) / 1500) * p.cos((curTime - timestamp) * 360 / 2000));
            }
          }
        }

        switch (flagTest) {
          case 0:
            // draw adaptation
            dotDir = 0;
            if (curTime - timestamp > 3000) {
              flagTest = 1;
              timestamp = curTime;
            }
            break;
          case 1:
            // draw test
            dotDir = 270;
            p.text('Test', 70, 20);
            if (curTime - timestamp > 500) {
              flagTest = 2;
              timestamp = curTime;
            }
            break;
          case 2:
            //response
            p.text('Response', 70, 20);
            if (curTime - timestamp > 3000) {
              flagTest = 0;
              timestamp = curTime;
            }
            break;
        }

      }


      function drawArrow(x, y, dir) {
        p.push();
        p.translate(150 + x, 150 + y);
        p.rotate(dir);
        //			p.line(0,-5,0,5);
        //			p.line(-2,3,0,5);
        //			p.line(2,3,0,5);
        p.line(-5, 0, 5, 0);
        p.line(3, -2, 5, 0);
        p.line(3, 2, 5, 0);
        p.pop();
      }

    };

    /* end of sketch environment */

    var myp5 = new p5(sketch);
  }

}
